import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getProduct,
  deleteProduct,
  exportProducts,
} from "../../api/productService";
import { getErrorMessage } from "../../utils/errorHandler";
import Pagination from "../Pagination/Pagination";
import Button from "../../utils/Buttons";

export default function ProductList() {
  const [products, setProducts] = useState([]);
  const [sampleFileUrl, setSampleFileUrl] = useState("");
  const [loading, setLoading] = useState(false);
  // SERVER PAGINATION
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(9);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  const navigate = useNavigate();

  const handleExportProduct = async () => {
    try {
      const response = await exportProducts();

      const blob = new Blob([response.data], {
        type: "text/csv",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "products.csv";

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  // FETCH PRODUCTS
  const fetchProducts = async (page = 1) => {
    setLoading(true);

    try {
      const res = await getProduct(page, itemsPerPage);
      const data = res?.data || [];
      setProducts(data);
      setSampleFileUrl(res?.SampleFileUrl || res?.data?.SampleFileUrl || "");
      setTotalItems(res?.pagination?.total || 0);
      setTotalPages(res?.pagination?.totalPages || 1);
    } catch (err) {
      alert(getErrorMessage(err));
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts(currentPage);
  }, [currentPage]);

  // VIEW PRODUCT
  const handleViewProduct = (slug) => {
    navigate(`/product/view/${slug}`);
  };

  // STAR RATING
  const renderStars = (rating = 0) => {
    const stars = [];

    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i
          key={i}
          className={`fa ${
            i <= Math.round(rating)
              ? "fa-star text-warning"
              : "fa-star-o text-muted"
          }`}
          style={{ marginRight: "2px" }}
        />,
      );
    }

    return stars;
  };

  // DELETE PRODUCT
  const handleDeleteProduct = async (id) => {
    try {
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this product?",
      );

      if (!confirmDelete) return;

      await deleteProduct(id);

      alert("Product deleted successfully");

      // REFRESH CURRENT PAGE
      fetchProducts(currentPage);
    } catch (error) {
      console.log(error);

      alert(getErrorMessage(error));
    }
  };

  return (
    <div className="container-fluid p-4 np-products-page">
      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Products List</h5>
        <div className="d-flex align-items-center gap-2">
          {/* Export CSV */}
          <button className="btn btn-success" onClick={handleExportProduct}>
            <i className="fa fa-download me-2"></i>
            Export CSV
          </button>

          {/* Import CSV */}
          <button
            className="btn btn-success text-white"
            onClick={() =>
              navigate("/product/import", {
                state: {
                  sampleFileUrl,
                },
              })
            }
          >
            <i className="fa fa-upload me-2"></i>
            Import CSV
          </button>

          {/* Add Product */}
          <button
            className="btn btn-primary"
            onClick={() => navigate("/product/add")}
          >
            <i className="fa fa-plus me-2"></i>
            Add Product
          </button>
        </div>
      </div>

      {/* LOADING */}
      {loading && <p>Loading Products...</p>}

      {/* EMPTY */}
      {!loading && products.length === 0 && (
        <p className="text-muted">No Products Found</p>
      )}

      {/* PRODUCT LIST */}
      <div className="row">
        {products.map((product) => (
          <div
            key={product._id}
            className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4"
          >
            <div
              className="card h-100 border-0 shadow-sm np-product-card"
              style={{
                overflow: "hidden",
                transition: "0.3s",
                cursor: "pointer",
                borderRadius: "12px",
              }}
            >
              {/* IMAGE */}
              <div
                style={{
                  height: "250px",
                  overflow: "hidden",
                  background: "#f8f8f8",
                  position: "relative",
                }}
              >
                <img
                  src={product?.seo?.metaImageUrl || "/default-product.png"}
                  alt={product?.productName}
                  className="w-100 h-100"
                  style={{
                    objectFit: "cover",
                    transition: "transform 0.3s ease",
                  }}
                  loading="lazy"
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                />

                {/* TOP RIGHT ICONS */}
              <div className="d-flex flex-column gap-2">
  {/* VIEW */}
  <Button
    icon={<i className="fa fa-eye text-light" title="View"></i>}
    onClick={(e) => {
      e.preventDefault();
      handleViewProduct(product.seo.slug);
    }}
    className="btn btn-sm btn-outline-light icon1"
  />

  {/* EDIT */}
  <Button
    icon={<i className="fa fa-pencil text-light" title="Edit"></i>}
    onClick={(e) => {
      e.preventDefault();

      navigate(`/product/edit/${product.seo.slug}`, {
        state: {
          productId: product._id,
          slug: product.seo.slug,
        },
      });
    }}
    className="btn btn-sm btn-outline-light icon2"
  />

  {/* DELETE */}
  <Button
    icon={<i className="fa fa-trash text-danger" title="Delete"></i>}
    onClick={(e) => {
      e.preventDefault();
      handleDeleteProduct(product._id);
    }}
    className="btn btn-sm btn-outline-light icon3"
  />
</div>

                {/* DISCOUNT */}
                {product?.discountPercent > 0 && (
                  <span
                    className="badge badge-primary"
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      fontSize: "12px",
                      padding: "6px 10px",
                    }}
                  >
                    {product?.discountPercent}% OFF
                  </span>
                )}
              </div>

              {/* CONTENT */}
              <div className="card-body d-flex flex-column">
                {/* NAME */}
                <h5
                  className="card-title mb-2"
                  style={{
                    fontWeight: "600",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: "#222",
                  }}
                >
                  {product?.productName}
                </h5>

                {/* RATING */}
                <div className="d-flex align-items-center mb-2">
                  <div>{renderStars(product?.rating || 0)}</div>

                  <span
                    className="ml-2 text-muted"
                    style={{
                      fontSize: "13px",
                    }}
                  >
                    ({product?.rating || 0})
                  </span>
                </div>

                {/* DESCRIPTION */}
                <p
                  className="card-text text-muted"
                  style={{
                    fontSize: "14px",
                    minHeight: "40px",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {product?.productDescription || "No description available"}
                </p>

                {/* PRICE */}
                <div className="d-flex align-items-center mt-auto">
                  <h5
                    className="mb-0 mr-2"
                    style={{
                      color: "#28a745",
                      fontWeight: "700",
                    }}
                  >
                    ₹{product?.variants[0]?.price?.toLocaleString("en-IN") || 0}
                  </h5>

                  {/* {product?.mrp > product?.price && (
                    <span
                      style={{
                        textDecoration: "line-through",
                        color: "#999",
                        fontSize: "14px",
                      }}
                    >
                      ₹{product?.mrp?.toLocaleString("en-IN")}
                    </span>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* PAGINATION */}
      {!loading && totalItems > 0 && (
        <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </div>
  );
}
